if (!customElements.get('drp-home-reasons')) {
  customElements.define('drp-home-reasons', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.querySelectorAll('details').forEach(detail => {
        detail.addEventListener('pointerenter', event => {
          if (event.pointerType !== 'mouse' || !matchMedia('(hover: hover) and (pointer: fine)').matches) return;
          clearTimeout(this.timer);
          this.timer = setTimeout(() => {
            if (this.keyboardMode && this.contains(document.activeElement) && !detail.contains(document.activeElement)) return;
            this.querySelectorAll('details').forEach(other => { other.open = other === detail; });
          }, 160);
        }, options);
        detail.addEventListener('pointerleave', () => clearTimeout(this.timer), options);
      });
      this.addEventListener('pointerdown', () => {
        this.keyboardMode = false;
        clearTimeout(this.timer);
      }, options);
      this.addEventListener('keydown', event => {
        this.keyboardMode = true;
        clearTimeout(this.timer);
        if (event.key === 'Escape') {
          clearTimeout(this.timer);
          const detail = event.target.closest('details');
          if (detail) { detail.open = false; detail.querySelector('summary').focus(); }
        }
      }, options);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.controller?.abort();
      this.controller = null;
    }
  });
}
